<template>
	<div>
		<el-dialog
		  :title="caseDetail.title"
		  :visible.sync="showDetail"
		  top="5vh"
		  width="60%">
		  
		  <div style="margin-top: 30px;margin-left: 10%;width: 80%;text-align: center;line-height: 40px;background-color: #606266;border-radius: 8px;color:white;word-wrap:break-word;">{{caseDetail.title}}</div>
		  <div style="margin-top: 30px;margin-left: 10%;width: 80%;margin-bottom:20px;" v-html="caseDetail.detail"></div>
		  <el-image v-for="item in caseDetail.url"
		        style="width: 80%; height: auto;margin-left:10%;"
		        :src="item"
		        fit="cover">
			      <div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
			        加载中...
			      </div>
			</el-image>
		</el-dialog>
		
		<div style="margin-left: 15%;text-align: left;width: 70%;">
		<el-carousel height="600px"  :interval="5000" arrow="always">
		  <el-carousel-item v-for="item in caseList" >
			<div style="position: relative;height: 100%;cursor: pointer;" @click="showDialog(item)">
				<el-image
				      style="width: 70%; height: 100%;vertical-align: top;"
				      :src="item.url[0]"
				      fit="cover">
				<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
				  加载中...
				</div>
				</el-image>
				<div :style="{display:'inline-block',height:'100%',width:'30%',backgroundImage: 'url(' + topImage + ')',backgroundSize:'100% 100%'}">
					
					
					<div style="margin-top: 30px;margin-left: 10%;width: 80%;text-align: center;line-height:25px;border-radius: 8px;color:white;word-wrap:break-word;font-weight:bold;font-size:18px;">{{item.title}}</div>
					
					<div style="margin-top: 30px;margin-left: 10%;width: 80%;color:white;word-wrap:break-word;line-height: 23px;" v-html="item.detail"></div>
				</div>
			</div>
		  </el-carousel-item>
		</el-carousel>
		</div>	  
		<div id="mainBox" style="margin-top: 30px;margin-left: 12%;text-align: left;width: 76%;">
			<div @click="showDialog(item)"  v-for="item in caseList" style="display: inline-block;margin:2%;width:21%;height: 270px;vertical-align: top;">
				<div class="messageBox">
					<el-image style="width: 100%; height: 150px;"
					:src="item.url[0]"
					fit="cover">
					<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
					  加载中...
					</div>
					</el-image>
					<div style="border-left: 1px solid #EBEEF5;border-bottom: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;">
						<div style="margin-left: 5%;width: 90%;height: 60px;line-height: 60px;border-bottom: 1px solid #EBEEF5;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;">{{item.title}}</div>
						<div style="margin-left: 5%;width: 90%;height: 40px;line-height: 40px;font-size: 12px;">查看更多
						<i class="el-icon-right"></i>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import utils from '@/utils';
	export default {
		name: "home",
		data() {
			return {
				topImage:utils.fileUrl()+'projectCase/background.jpg',
				showDetail:false,
				caseDetail:{
					url:[],
				},
				caseList:[
				],
			}
		},
		methods: {
			showDialog(item){
				this.caseDetail = item;
				this.showDetail = true;
			},
		},
		mounted() {
			this.caseList = this.$store.state.projectCase;
			
			window.scrollTo(0,0);
			var that =this;
			if(this.$route.query.id != undefined){
				for(let i=0;i<this.caseList.length;i++){
					if(this.caseList[i].id == this.$route.query.id){
						setTimeout(function(){
						   that.caseDetail = that.caseList[i];
						   that.showDetail = true;
						}, 300);
					}
				}
			}
		}
	}
</script>

<style>
	.messageBox{
		cursor: pointer;
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		/* Opera */
	}
	
	.messageBox:hover{
		margin-top:-15px;
	}
	#mainBox::-webkit-scrollbar {
	            /*滚动条整体样式*/
	            width: 20px;
	            /*高宽分别对应横竖滚动条的尺寸*/
	            height: 20px;
	        }
	        #mainBox::-webkit-scrollbar-button{
	
	     
	        }
	        #mainBox::-webkit-scrollbar-thumb {
	            /*滚动条里面小方块*/
	            border-radius: 10px;
	            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	            /* background: #535353; */
	            background-color: skyblue;
	            background-image: -webkit-linear-gradient(45deg,
	            rgba(255, 255, 255, 0.2) 25%,
	            transparent 25%,
	            transparent 50%,
	            rgba(255, 255, 255, 0.2) 50%,
	            rgba(255, 255, 255, 0.2) 75%,
	            transparent 75%,
	            transparent);
	        }
	
	        #mainBox::-webkit-scrollbar-track {
	            /*滚动条里面轨道*/
	            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	            border-radius: 10px;
	            background-color: #fff;
	        }
	        #mainBox::-webkit-scrollbar-track-piece {
	            border-radius: 100px;
	        }
	
	        #mainBox{  position:relative; overflow:auto; margin:50px auto;
	
	
	        }
</style>